import * as ActionTypes from 'state/types'

const initialState = {
  requests: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_REGISTER: {
      const {
        requestKey
      } = action.payload

      const newRequests = {
        ...state.requests
      }

      newRequests[requestKey] = newRequests[requestKey] + 1 || 1

      return {
        ...state,
        requests: newRequests
      }
    }

    case ActionTypes.REQUEST_UNREGISTER: {
      const {
        requestKey
      } = action.payload

      const newRequests = {
        ...state.requests
      }

      delete newRequests[requestKey]

      return {
        ...state,
        requests: newRequests
      }
    }

    default:
      return state
  }
}
